<template>
    <BreadCrumb PageTitle="Ajouter un abonnement MPOSTBOX" />
    <AddMpostBox />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddMpostBox from "../../components/MpostBox/AddMpostBox.vue";
  
    export default defineComponent({
      name: "AddMpostBoxPage",
      components: {
        BreadCrumb,
        AddMpostBox,
      },
    });
  </script>